pageId = 'page-signin'
page = '#' + pageId

$ ->
  $page = $(page)

  if location.href.indexOf('dingtalk_qr_failure') > 0
    simple.dialog.message
      width: 400
      content: '你的钉钉还没绑定 Tower 帐号。'

  $signPage = $page.find '.dingtalk-sign-in-page'
  if $signPage.length > 0 && window.DDLogin
    dingtalkLogin()

  $mobileSigninForm = $page.find '.mobile-signin-form'
  if $mobileSigninForm.length > 0
    tower.initMobileVerification $mobileSigninForm

  $('#wx-login-remember-me').on 'change', (e) ->
    if e.target.checked
      $.ajax('/users/wechat_sign_in/auto_login', method: 'post')
    else
      $.ajax('/users/wechat_sign_in/auto_login', method: 'delete')


dingtalkLogin = ->
  $iframe = $('#dingtalk-login iframe')
  return if $iframe.length
  url = $('#dingtalk-sns-url').val()

  DDLogin
    id: 'dingtalk-login'
    goto: url
    href: '//tower.im/dingding-signin.css'
  $iframe.height 300

  hanndleMessage = (event) ->
    return if event.origin.indexOf('dingtalk') < 0
    location.href = decodeURIComponent("#{ url }&loginTmpCode=#{ event.data }")

  if typeof window.addEventListener != 'undefined'
    window.addEventListener 'message', hanndleMessage, false
  else if typeof window.attachEvent != 'undefined'
    window.attachEvent 'onmessage', hanndleMessage
